module.exports = __webpack_public_path__ + "img/logo5.dbc244e2.webp";